export default __webpack_public_path__ + "static/media/seniors-rights-victoria.26cf1df3.png";